<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/pc_banner_cooperation.jpg`)">
      <div class="content pos-relative">
        <go-to-top />

        <h1 class="main-title">
          友達紹介コンプポイント
        </h1>

        <p class="content-p-text text_center pb_5 ">
          紹介者リンクを通じて登録した友達がベットした金額の0.1%をコンプポイントとしてプレゼント。無制限でGET可能です。
        </p>
        <h1 class="main-title mt_5">
          友達紹介ボーナス
        </h1>

        <p class="content-p-text text_center pb_5">
          紹介者リンクを通じて登録した友達が入金すると、1名につき1,000円の友達紹介ボーナスをプレゼント。
        </p>

        <h1 class="main-title">
          友達紹介ボーナス規約
        </h1>

        <ul class="list-type-disc pb_5 ps_2">
          <li class="pb_5">
            「利用規約およびイベント規約」が適用されます。
          </li>
          <li class="pb_5">
            当ボーナスを獲得するには、紹介された方が紹介者から提供された専用URLを使用して登録を完了する必要があります。
          </li>
          <li class="pb_5">
            友達紹介ボーナスおよび友達紹介コンプポイントは【アフィリエイトウォレット】に送られ、すぐに出金することが可能です。
          </li>
          <li class="pb_5">
            本イベントを不正に利用した場合、またはその他の不正行為が発覚した場合、勝 winはお客様のすべてのイベントやプロモーションへの参加を停止し、【アフィリエイトウォレット】の残高を没収するほか、アカウントやその他の権利を停止いたします。
          </li>
          <li class="pb_5">
            当サイトは予告なく本イベントを中止または変更する権利を留保します。
          </li>
        </ul>

        <hr class="hr_line hr_my_3rem">

        <h1 class="main-title">
          友達紹介コンプポイントとは？
        </h1>

        <div class="how-to-frame">
          <div class="how-to-box">
            <img class="how-to-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/how_to_join_1.webp`)" alt="">

            <p class="fw_bold text_center">
              ◆ 30秒ほどで登録でき、紹介者専用リンクを受け取ります
            </p>
          </div>
          <div class="how-to-box">
            <img class="how-to-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/how_to_join_2.webp`)" alt="">

            <p class="fw_bold text_center">
              ◆ 友達が登録に成功し、且つ入金 が完了した後、勝winよりギフトを進呈
            </p>
          </div>
          <div class="how-to-box">
            <img class="how-to-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/how_to_join_3.webp`)" alt="">
            <p class="fw_bold text_center">
              ◆ 業界初、即出金可能！
            </p>
          </div>
        </div>
        <hr class="hr_line hr_my_3rem">

        <h1 class="main-title">
          友達紹介ボーナス
        </h1>

        <ul class="list-type-disc pb_5 ps_2">
          <li class="pb_5">
            毎回、友達がお客様がシェアしたリンクを経由して勝winに参加するたびに、お客様は友達紹介ボーナスとして1,000円のボーナスを獲得できます。
          </li>
          <li class="pb_5">
            お客様のリンクを経由して勝winに参加する人が増えれば増えるほど、より多くの友達紹介ボーナスを獲得できます。
          </li>
        </ul>

        <hr class="hr_line hr_my_3rem">

        <h1 class="main-title">
          永続的な収益
        </h1>

        <div class="income-frame">
          <div class="income-box">
            <div class="income-box th">
              ライブカジノゲームのベットリベート
            </div>
            <div class="fs_5 fw_bold tbody text_center">
              N x (ベット額 x 0.1%)
            </div>
          </div>
          <div class="income-box plus">
            +
          </div>
          <div class="income-box">
            <div class="income-box th">
              スロットゲームのベットリベート
            </div>
            <div class="fs_5 fw_bold tbody text_center">
              N x (ベット額 x 0.1%)
            </div>
          </div>
        </div>

        <p class="content-p-text text_center">
          ライブカジノゲームのベットリベート0.1%
        </p>

        <p class="content-p-text text_center">
          スロットゲームのベットリベート0.1%
        </p>

        <p class="content-p-text text_center">
          お客様にご紹介された友達が【現金ウォレット】を使用し、ライブ&テーブルゲームにベットした場合、お客様はすべてのベットに対する0.1%を受け取ることができます。例：友達が10,000,000をベットした場合、お客様は10,000,000×0.1%＝10,000のリベートを獲得できます。
        </p>

        <img class="img-bonusIntroducing" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/permanentIncome.webp`)" alt="">

        <hr class="hr_line hr_my_3rem">

        <h1 class="main-title">
          よくある質問
        </h1>
        <ul class="list-type-disc pb_5 ps_2">
          <li class="pb_5">
            メンバー登録は無料ですか？
          </li>
          <li class="pb_5">
            無料な上に、体験ボーナスも受け取れます。
          </li>
          <li class="pb_5">
            初心者でもリベートを受け取ることができますか？
          </li>
          <li>「友達紹介コンプポイント」の特徴は、敷居が非常に低いことで、早く始めれば始めるだけチャンスが大きくなり、新規登録の無料体験イベントと組み合わせることで、半分の負担で2倍の効果が得られます。</li>
          <li class="pb_5">
            「友達紹介ボーナス」のボーナスは、どのように獲得できますか？
          </li>
          <li class="pb_5">
            プロジェクトイベント内の専用リンクをコピーし手順を踏んだ後、友達がそのリンクから登録をすると、コンプポイントを獲得できます。
          </li>
        </ul>

        <hr class="hr_line hr_my_3rem">

        <h1 class="main-title text-color-primary">
          注意事項
        </h1>

        <ul class="list-type-disc ps_2">
          <li class="pb_5">
            「利用規約およびイベント規約、条件」が適用されます。
          </li>
          <li class="pb_5">
            本プロジェクトに参加するには、紹介された方が紹介者から提供されたURLを使用して登録を完了する必要がございます。
          </li>
          <li class="pb_5">
            紹介者ボーナスは【アフィリエイトウォレット】に送られ、すぐに出金することが可能です。
          </li>
          <li class="pb_5">
            本イベントを不正に利用した場合およびその他の不正行為を行った場合は、勝winがお客様のすべてのイベントやプロモーションへの参加を停止し、【ボーナスウォレット】の残高を没収、さらにアカウントやその他の権利を停止いたします。
          </li>

          <li class="pb_5">
            当サイトは予告なく本イベントの中止または変更する権利を留保いたします。
          </li>
        </ul>

        <hr class="hr_line hr_my_3rem">
        <h1 class="main-title text-color-primary ">
          勝win 安心‧安全にプレイ
        </h1>

        <p class="content-p-text">
          勝winは、Initial Singularity Limitedによって所有および運営されております。
        </p>

        <p class="content-p-text">
          登録番号: 15679 登録住所: Hamchako, Mutsamudu, Autonomous Island of Anjouan Union of Comoros.
        </p>

        <img class="useful-circle-pic pic-agent-validSeal" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/agent_validSeal.webp`)" alt="">

        <p class="content-p-text ">
          勝winはライセンスを取得しており、コモロ連合アンジュアン自治島政府によって規制されており、ライセンス番号: 15679に基づいて運営されております。
        </p>

        <p class="content-p-text ">
          勝winはすべての規制遵守条件を満たしており、あらゆる賭けとギャンブルのゲームの運営を行う法的権限を与えられております。
        </p>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'PageCooperation',
  components: {
    goToTop
  },
  data() {
    return {
      // ... your existing data properties
    }
  },
  computed: {
    footerIframe() {
      return 'https://katsuwin.info/iframe/shareproject'
    }
  },
  mounted() {
    this.addIframeClickListener()
  },
  methods: {
    addIframeClickListener() {
      const iframe = this.$refs.myIframe
      if (!iframe) return

      iframe.onload = () => {
        try {
          const innerDoc = iframe.contentDocument || iframe.contentWindow.document
          innerDoc.addEventListener('click', this.handleIframeClick)
        } catch (e) {
          console.error('Error accessing iframe content:', e)
        }
      }
    },
    handleIframeClick(event) {
      if (event.target.tagName === 'A') {
        event.preventDefault()
        this.$router.push('/event')
      }
    }
  }
}
</script>

